import React from 'react';
import { Field } from 'redux-form';
import { Col } from 'react-bootstrap';
import { hasPermission } from '../../../../auth/redux/authActions';

import { OverrideFormControl } from '../../../../../common/components';

const AdminFeeAdjust = ({
  selectedScheme,
  isPremiumAdjusting,
  applyAdminFeeOverride,
}) => {
  if (!selectedScheme || !hasPermission('policy.premium_overrides_fees')) {
    return null;
  }

  const adminFee = selectedScheme.premium.ex_tax.toFixed(2);

  return (
    <Col xs={12} className="admin-fee-container">
      <h4>Admin Fee</h4>
      <Field
        name={'data.attributes.metadata.overrides.admin_fee_ex_tax'}
        currency
        labelSize={2}
        placeholder={`${adminFee}`}
        component={OverrideFormControl}
        isCalc={isPremiumAdjusting}
        className="text-right"
        handleApplyButton={applyAdminFeeOverride}
      />
    </Col>
  );
};

export default AdminFeeAdjust;
